import { Box, Icon, colors } from '@factorialco/deprecated-design-system'

import { ActivationCenterResourceType } from '../enums'

interface StatusCircleProps {
  type: ActivationCenterResourceType
}

export const StatusCircle = ({ type }: StatusCircleProps) => {
  const size = 's16'

  switch (type) {
    case ActivationCenterResourceType.FILLED:
      return (
        <Box
          width={size}
          height={size}
          alignItems="center"
          justifyContent="center"
          borderRadius={{ all: 'rel500' }}
          background="viridian1000"
          padding="s2"
          aria-label="resource-filled"
        >
          <Icon.Small icon="check" color="grey000White" />
        </Box>
      )
    case ActivationCenterResourceType.MISSING_DATA:
      return (
        <Box
          width={size}
          height={size}
          borderRadius={{ all: 'rel500' }}
          border={{ all: { color: 'grey700', style: 'solid', width: 's2' } }}
          padding="s2"
          style={{
            background: `conic-gradient(${colors.grey700} 50%, transparent 50%)`,
          }}
          aria-label="resource-missing-data"
        />
      )
    case ActivationCenterResourceType.NOT_ENABLED:
      return (
        <Box
          width={size}
          height={size}
          borderRadius={{ all: 'rel500' }}
          border={{ all: { color: 'grey700', style: 'solid', width: 's2' } }}
          padding="s2"
          aria-label="resource-not-enabled"
        />
      )
  }
}
